<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<header>
<h1 class="topictitle1" id="to3"><a href="#/nav#nto3"><span class="first_text">Map</span></a></h1>
</header>
<div class="fignone" id="id-36676-ProphetsOfTheGhostAnts_9780062429735_approved_ms_topic_9--fig-2-0-0">
<div class="figbody"><img alt="9780062429735_PoTGAmap.jpg" src="9780062429735_PoTGAmap.jpg"/></div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Map.vue?cad68658